// Path-to-space rule, shared by `middleware/access-guard.global.ts` and the feature map
// generator (`scripts/feature-map/`), see docs/adr/0005-*.
// Keep this file free of imports, enums and `~` aliases: the generator imports it from plain
// Node, which only strips type annotations.

export type RouteSpace = "auditor" | "city" | "user";

/** Whether a route path belongs to the city space, `/city` and everything under that prefix. */
export function isCityPath(path: string): boolean {
  return path.startsWith("/city");
}

/**
 * Whether a page's declared roles let the `user` space reach it as well: any role other
 * than the auditor one. Only matters for `/audit-passengers` routes.
 */
export function opensUserSpace(routeRoles: string[], auditorRole: string): boolean {
  return routeRoles.some(role => role !== auditorRole);
}

/**
 * @param path route path without tenant segment, e.g. `/city/invoices`
 * @param pageOpensUserSpace result of `opensUserSpace` for the page's roles
 */
export function spacesOfPath(path: string, pageOpensUserSpace: boolean): RouteSpace[] {
  if (path === "/choice-space") return ["auditor", "city", "user"];
  if (isCityPath(path)) return ["city"];
  if (path.startsWith("/audit-passengers")) return pageOpensUserSpace ? ["auditor", "user"] : ["auditor"];
  return ["user"];
}
